import React from 'react'
import ReactModal from 'react-modal'
import { useTranslation } from 'react-i18next'
import '../../styles/modals/AchievementInfoModal.css'
import { ReactComponent as CloseModalIcon } from '../../svg/normalSvgs/CloseModalIcon.svg'
import { ReactComponent as CheckMark } from '../../svg/normalSvgs/CheckMark.svg'
import ProgressBar from '../ProgressBar'
import { pluralize } from '../../utils/util'

function AchievementInfoModal({ modalIsOpen, closeModal, achievement }) {
    const { t } = useTranslation()

    React.useEffect(() => {
        if (modalIsOpen) {
            ReactModal.setAppElement('#root')
            document.getElementById('feedid').style.filter = 'blur(5px)'
        } else {
            document.getElementById('feedid').style.filter = 'unset'
        }
    }, [modalIsOpen])

    return (
        <ReactModal
            transparent
            isOpen={modalIsOpen}
            ariaHideApp={false}
            onAfterOpen={() => {}}
            onAfterClose={() => {}}
            onRequestClose={closeModal}
            style={{
                overlay: {
                    zIndex: 3,
                    overflowY: 'scroll',
                    height: '100vh',
                },
                content: {
                    inset: 0,
                    padding: 0,
                    backgroundColor: 'transparent',
                    border: 'none',
                    borderRadius: 10,
                    boxShadow: 'none',
                    overflow: 'hidden',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: 10,
                },
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    top: 110,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="how-are-you-modal-icon" onClick={() => closeModal()}>
                    <CloseModalIcon />
                </div>
            </div>
            <div className="achievement-modal-cont ">
                <div className="achievement-modal-inner">
                    <div className="achievement-modal-header">
                        <div style={{ width: 114, height: 94 }}>
                            <img src={achievement.image} alt={achievement.name} id={achievement.image} />
                        </div>
                        <div className="achievement-modal-title">
                            <div>{achievement.name}</div>
                        </div>
                    </div>
                    <div className="achievement-modal-description ">
                        <div className="achievement-modal-description-title">
                            <div className="achievement-modal-description-title-text">{t('Task Description')}:</div>
                            <div className="achievement-modal-description-title-points">
                                {achievement.rewarding_points} {t(pluralize('point', achievement.rewarding_points))}
                            </div>
                        </div>
                        <div className="achievement-modal-description-list">
                            {achievement.tasks?.map((item, index) => {
                                const isCompleted = item.collected === item.collecting_target
                                return (
                                    <div className="achievement-modal-description-item" key={index}>
                                        <div className="achievement-modal-description-item-text" style={{ color: isCompleted ? '#6FCC87' : '#9392AD' }}>
                                            {index + 1}. {item.description}
                                        </div>
                                        {isCompleted && (
                                            <div>
                                                <CheckMark />
                                            </div>
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                        <div className="achievement-modal-progress-bar">{t('Progress bar')}</div>
                        <ProgressBar completed={achievement.progress} backgroundColor="#153c4f" />
                    </div>
                    {/* <div className='achievement-modal-button-container'>
						<button className='achievement-modal-button-select'>{t('Select as goal')}</button>
						<button className='achievement-modal-button-close' onClick={() => closeModal()}>
							{t('closePopup')}
						</button>
					</div> */}
                </div>
            </div>
        </ReactModal>
    )
}

export default AchievementInfoModal
